<template>
  <div class="pa-3">
    <div class="item">
      <v-skeleton-loader
        type="text"
        width="70"
      />
      <v-skeleton-loader
        type="text"
        width="80"
      />
    </div>
    <div v-if="showMyJobs" class="item">
      <v-skeleton-loader
        type="text"
        width="60"
      />
      <v-skeleton-loader
        type="text"
        width="50"
      />
    </div>
    <div
      v-for="filter in numOfFilterCategories"
      :key="filter"
    >
      <v-skeleton-loader
        type="text"
        width="180"
        class="pt-1 pb-1"
      />
      <div
        v-for="num in 3"
        :key="num"
        class="item"
      >
        <v-skeleton-loader
          type="text"
          width="150"
        />
        <v-skeleton-loader
          type="text"
          width="40"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  showMyJobs: {
    type: Boolean,
    default: true,
  },
  numOfFilterCategories: {
    type: Number,
    default: 2,
  },
});
</script>

<style lang="less" scoped>
.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

:deep(.v-skeleton-loader__text) {
  margin: 12px;
}
</style>
